import { addExperimentGroupToTargeting } from '../';
import { BaseServiceSetup, context, utils } from '@wikia/ad-engine';

const logGroup = 'ServerSideExperiment';

export class SSExperiment extends BaseServiceSetup {
	call(): void {
		const classNamePattern = /^sse-(.+?)-(control|variant\d+)$/;

		const expClassNames = [...document.documentElement.classList].find((className) =>
			classNamePattern.test(className),
		);

		if (!expClassNames) {
			utils.logger(logGroup, 'No Server side experiment is running on this bucket');
			return;
		}

		const match = expClassNames.match(classNamePattern);

		if (!match) {
			return;
		}

		const [, expName, expVariant] = match;
		const isControl = expVariant === 'control';

		addExperimentGroupToTargeting(`${expName}-${expVariant}`);

		utils.logger(logGroup, {
			reportedExperimentGroupValue: `${expName}-${expVariant}`,
			expName,
			expVariant,
			isControl,
		});

		utils.logger(logGroup, `experiments.${expName}`, !isControl);
		context.set(`experiments.${expName}`, !isControl);
	}
}
